export const TEAMS_PAGE = 'reports/company/TEAMS_PAGE'
